module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/cakes-desserts-tile-240e9b4200678230cee88ba661fd8ad0.jpg";